import { render } from "./BackendView.vue?vue&type=template&id=709679e6&scoped=true&ts=true"
import script from "./BackendView.vue?vue&type=script&lang=ts"
export * from "./BackendView.vue?vue&type=script&lang=ts"

import "./BackendView.vue?vue&type=style&index=0&id=709679e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709679e6"]])

export default __exports__